// Angular imports
import { Component, EventEmitter, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';

// CC-Common imports
import { DxWidgetUtils, Utils } from 'cc-common';

// devextreme imports
import { DxPopupComponent } from 'devextreme-angular';

// component imports
import { BoardApprovalBaseComponent } from '../../../board-approval/_base/board-approval-base.component';

// Model imports
import { BoardApprovalCollectionReferralResultDto } from '../../_models/board-approval-collection-referral-result-dto';
import { BoardApprovalDetailParameterDto } from '../../_models/board-approval-detail-parameter-dto';

@Component({
    selector: 'app-collection-referral-detail',
    templateUrl: './collection-referral-detail.component.html',
    styleUrls: ['./collection-referral-detail.component.scss']
})
export class CollectionReferralDetailComponent extends BoardApprovalBaseComponent implements OnInit {
    @ViewChild('collectionReferralDetail', { static: false }) collectionReferralDetail: DxPopupComponent;

    @Input() collectionsDetail: BoardApprovalCollectionReferralResultDto =
        new BoardApprovalCollectionReferralResultDto();
    @Input() processId: string;
    @Input() communityId: number;
    @Input() processText: string;
    @Input() visible = false;
    @Input() mode: string;

    @Output() onClose = new EventEmitter<boolean>();

    popupTitle = '';

    constructor(protected readonly injector: Injector) {
        super(injector);
    }

    ngOnInit() {
        if (Utils.notNullAndDefined(this.processText)) {
            this.popupTitle = this.processText;
        }
    }

    onPopupShown(): void {
        DxWidgetUtils.instantRepaint(this.collectionReferralDetail);
    }

    onPopupHidden(): void {
        this.visible = false;
        this.onClose.emit(false);
    }

    onCancelClick(): void {
        this.onPopupHidden();
    }

    onViewStatementClick(): void {
        const baseParams: BoardApprovalDetailParameterDto = new BoardApprovalDetailParameterDto();
        baseParams.communityId = this.communityId;
        baseParams.processId = this.processId;
        const fileName = `Statement_${this.processText}.pdf`;

        this.boardApprovalHelperService.showLoading();
        this.sharedBoardApprovalService.downloadCollectionStatement(baseParams).subscribe(
            (fileData: Blob) => {
                this.helperService.showBlobInBrowserTab(fileData, fileName);
                this.boardApprovalHelperService.hideLoading();
            },
            (error) => {
                this.boardApprovalHelperService.hideLoading();
                this.errorService.displayError(error);
            }
        );
    }
}
